<script setup lang="ts">
import {
  IElement,
  UIBuilderSpacing,
  onChangeMarginPadding,
  isValidHandleBars,
  validateHandlebarVariableExistInCustomValues,
  getMarginProperties,
  getPaddingProperties,
  useCustomValues,
} from '@gohighlevel/ghl-proposals-common'
import { PropType, onMounted, ref, watch, computed } from 'vue'
import { UIAlert } from '@gohighlevel/ghl-ui'
import { useAppStore } from '@/store/app'
import { useI18n } from 'vue-i18n'
import { useElementOption } from '@/composable/elementOptions'
import { useBuilderStore } from '@/store/builder'

const { t } = useI18n()
const appStore = useAppStore()
const builderStore = useBuilderStore()
const props = defineProps({
  element: Object as PropType<IElement>,
})
const { updateStyles } = useElementOption()
const {
  locationStaticCustomValues,
  locationCustomValues,
  locationCustomFields,
} = useCustomValues()
const margin = ref(getMarginProperties(props.element))
const padding = ref(getPaddingProperties(props.element))
const errorMessage = ref()

watch(props, _newValue => {
  if (props.element) {
    margin.value = getMarginProperties(props.element)
    padding.value = getPaddingProperties(props.element)
  }
  validateCustomVariables()
})

onMounted(() => {
  validateCustomVariables()
})

const allDocumentVariables = computed(() => [
  ...(appStore.document?.variables || []),
  ...builderStore.getAllLinkedDocumentVariables(),
])

const onBoxStyleChange = onChangeMarginPadding(updateStyles)
const validateCustomVariables = () => {
  if (props?.element?.component?.options?.text) {
    const isValid = isValidHandleBars(props?.element?.component?.options?.text)

    // check the custom values are actually there in the constants.
    const errorCustomValues = validateHandlebarVariableExistInCustomValues(
      props?.element?.component?.options?.text,
      locationStaticCustomValues.value,
      locationCustomValues.value,
      locationCustomFields.value,
      allDocumentVariables.value
    )
    const isCustomValid: boolean =
      errorCustomValues && errorCustomValues.length > 0 ? true : false
    if (isCustomValid || !isValid) {
      if (isCustomValid) {
        errorMessage.value = errorMessage.value = `${t(
          'validations.customVariables.validPart1'
        )}  ${errorCustomValues.toString()} ${t(
          'validations.customVariables.validPart2'
        )}`
      }
      if (!isValid) {
        errorMessage.value = t('validations.customVariables.issueMsg')
      }
    } else {
      errorMessage.value = ''
    }
  }
}
</script>

<template>
  <div class="my-2">
    <UIAlert
      id="estimate-table-style-warning"
      :title="$t('common.warning')"
      type="warning"
      v-if="errorMessage"
    >
      <!-- <template #title>Action</template> -->
      <template #content>{{ errorMessage }}</template></UIAlert
    >
  </div>
  <UIBuilderSpacing :element="props.element" @onUpdate="onBoxStyleChange" />
</template>
